export default {
	getStripeClientSecret (data) {
		const requestCancelLabel = 'QGetStripeClientSecret'
		this.cancelQRequest(requestCancelLabel)

		const params = {
			...data,
			...(data.line_items && {
				line_items: data.line_items.map((item) => ({ ...item, quantity: Number(item.quantity) }))
			})
		}
		return this.postRequest('/api/private/stripe/checkout', params, requestCancelLabel)
	},

	getStripeSessionStatus (id) {
		const requestCancelLabel = 'QStripeSessionStatus'
		this.cancelQRequest(requestCancelLabel)

		const params = { session_id: id }
		return this.getRequest('/api/private/stripe/sessionstatus', params, requestCancelLabel)
	},
}
